var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBroadcaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "broadcaster") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.6858026%",
    y1: "-2.36068216e-07%",
    x2: "90.933854%",
    y2: "144.448005%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1CD2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B20DFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-20.7662137%",
    y1: "-38.8862043%",
    x2: "0.576865526%",
    y2: "104.03033%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1CD2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B20DFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "broadcaster",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6773,22.1533 C17.3698,22.1533 18.8182,21.5507 20.0233,20.3461 C21.2282,19.1415 21.8307,17.6924 21.8307,16 L21.8307,6.15401 C21.8307,4.46162 21.2286,3.01305 20.0233,1.80784 C18.8182,0.602907 17.3698,0 15.6773,0 C13.9849,0 12.5363,0.602907 11.3311,1.80784 C10.1259,3.01285 9.52344,4.46162 9.52344,6.15401 L9.52344,16 C9.52344,17.6923 10.1262,19.1415 11.3311,20.3461 C12.5361,21.5507 13.9849,22.1533 15.6773,22.1533 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6773,22.1533 C17.3698,22.1533 18.8182,21.5507 20.0233,20.3461 C21.2282,19.1415 21.8307,17.6924 21.8307,16 L21.8307,6.15401 C21.8307,4.46162 21.2286,3.01305 20.0233,1.80784 C18.8182,0.602907 17.3698,0 15.6773,0 C13.9849,0 12.5363,0.602907 11.3311,1.80784 C10.1259,3.01285 9.52344,4.46162 9.52344,6.15401 L9.52344,16 C9.52344,17.6923 10.1262,19.1415 11.3311,20.3461 C12.5361,21.5507 13.9849,22.1533 15.6773,22.1533 Z",
    id: "Path",
    fillOpacity: 0.3,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3888,12.6731 C26.1459,12.4295 25.8568,12.3076 25.5234,12.3076 C25.1904,12.3076 24.902,12.4295 24.6581,12.6731 C24.4147,12.9167 24.293,13.2051 24.293,13.5383 L24.293,16 C24.293,18.3718 23.4498,20.4006 21.7639,22.0864 C20.0785,23.7723 18.0495,24.6153 15.6775,24.6153 C13.3057,24.6153 11.2769,23.7723 9.59089,22.0864 C7.90509,20.401 7.06226,18.3719 7.06226,16 L7.06226,13.5383 C7.06226,13.2051 6.94041,12.9167 6.69692,12.6731 C6.45329,12.4295 6.16514,12.3076 5.83159,12.3076 C5.49804,12.3076 5.20956,12.4295 4.96606,12.6731 C4.72237,12.9167 4.60059,13.2051 4.60059,13.5383 L4.60059,16 C4.60059,18.8333 5.54627,21.2981 7.4371,23.3941 C9.32799,25.4901 11.6645,26.6919 14.4467,26.9994 L14.4467,29.5381 L9.52373,29.5381 C9.19038,29.5381 8.90196,29.6601 8.6584,29.9037 C8.41477,30.1472 8.29293,30.4357 8.29293,30.7691 C8.29293,31.1019 8.41477,31.391 8.6584,31.6344 C8.90196,31.8778 9.19038,32 9.52373,32 L21.831,32 C22.1643,32 22.4531,31.8779 22.6963,31.6344 C22.9402,31.391 23.0622,31.1019 23.0622,30.7691 C23.0622,30.4358 22.9402,30.1472 22.6963,29.9037 C22.4532,29.6601 22.1644,29.5381 21.831,29.5381 L16.9086,29.5381 L16.9086,26.9994 C19.6904,26.6919 22.0267,25.4901 23.9178,23.3941 C25.8089,21.2981 26.7548,18.8333 26.7548,16 L26.7548,13.5383 C26.7548,13.2051 26.6327,12.9169 26.3888,12.6731 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcaster);
export default __webpack_public_path__ + "static/media/broadcaster.06e37e10d60dabcce52ca944e68c2fb8.svg";
export { ForwardRef as ReactComponent };